import React from 'react';
import { IonButton } from '@ionic/react';
import { useSwiper } from 'swiper/react';
import { useIsNative } from '../utils/useIsNative';
import { initCap } from '../utils/format';
import { WelcomeSlide } from './WelcomeSlide';
import { SlideHeading } from './SlideHeading';
import { SlideActions } from './SlideActions';
import { SlideButton } from './SlideButton';

export const NOTIFICATIONS_SLIDE_HEADING = 'Get Reminded to Record';

interface INotificationsSlideProps {
    notificationPermission: string;
    onRequestPermission: () => Promise<void>;
    onSkip: () => void;
}

export const NotificationsSlide: React.FC<INotificationsSlideProps> = ({ notificationPermission, onRequestPermission, onSkip }) => {
    const swiper = useSwiper();
    const isNative = useIsNative();

    const canRequest = !['granted', 'denied', 'disabled'].includes(notificationPermission);
    const statusMsg = ['granted', 'denied'].includes(notificationPermission) ? `Permission ${initCap(notificationPermission)}` : '';

    const onTurnOn = async () => {
        if (canRequest) {
            await onRequestPermission();
        }
        swiper.slideNext();
    };

    const onMaybeLater = () => {
        onSkip();
        swiper.slideNext();
    };

    return (
        <WelcomeSlide image="3-notifications.webp">
            <SlideHeading
                title={NOTIFICATIONS_SLIDE_HEADING}
                description={<>Allow notifications for calendar reminders<br/>so you <b>never forget</b> to capture notes.</>}
            />
            <SlideActions>
                {!isNative &&
                    <IonButton fill="clear" type="button" onClick={() => swiper.slidePrev()}>&lt; Back</IonButton>
                }
                {canRequest ? (
                    <>
                        <IonButton fill="clear" type="button" onClick={onMaybeLater}>Maybe later</IonButton>
                        <SlideButton onClick={onTurnOn}>Yes, turn on</SlideButton>
                    </>
                ) : (
                    <>
                        {statusMsg &&
                            <div style={{fontSize: 14, padding: '10px 0'}}>{statusMsg}</div>
                        }
                        <SlideButton onClick={() => swiper.slideNext()}>Continue</SlideButton>
                    </>
                )}
            </SlideActions>
        </WelcomeSlide>
    );
};
